<div class="container">
    <div class="sopo-popup-title">
        Ring join requests
    </div>

    <div class="details">
        <div class="request">Requests: <span>{{ requestedRegistrations.length }}</span></div>
        <div class="table-name"><span>{{ tableName }}</span></div>
    </div>
    <div
        class="ion-activatable clickable"
        (click)="acceptAllRequsets()"
        [ngClass]="requestedRegistrations.length === 0 ? 'sopo-popup-grey-button' : 'sopo-popup-green-button'"
    >
        Accept All
        <ion-ripple-effect></ion-ripple-effect>
    </div>

    <img class="line" src="assets/img/lobby/ellipse.svg">

    <div class="request-list scrollable">
        <ng-container *ngIf="requestedRegistrations.length > 0 else noRequest">
            <app-game-request-item
                [userId]="userId"
                [tournamentType]="tournamentType"
                [tournamentId]="tableId"
                [clubId] = "clubId"
                [isRegistartionRequest]="true"
                [gameServerUrl]="gameServerUrl"
                [gameStateId]="gameStateId"
                [isTableInfo]="isTableInfo"
                *ngFor="let userId of requestedRegistrations">
            </app-game-request-item>
        </ng-container>
    </div>
</div>

<ng-template #noRequest>
    <div class="sopo-popup-text">
        No registration requests pending.
    </div>
</ng-template>
